/** Comma-separated website base URLs, e.g. `https://www.carvia.de,https://www.carvia.com` */
export const WEBSITE_URLS = import.meta.env.VITE_WEBSITE_URLS as string | undefined;
